<template>
  <div class="addMenu">
    <!--新增-->
    <el-dialog
      :title="$t('menu.insertTitle')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="460px"
    >
      <el-form
        label-width="auto"
        :rules="rules"
        :model="addInfo"
        ref="insertDialog"
        :label-position="'right'"
      >
        <el-form-item :label="$t('menu.menuName')" prop="menuName">
          <el-input
            v-model="addInfo.menuName"
            :placeholder="$t('menu.namePlaceholder')"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('menu.type')" prop="type">
          <el-select
            v-model="addInfo.type"
            :placeholder="$t('menu.typePlaceholder')"
            style="width: 100%"
            filterable
          >
            <el-option :label="$t('menu.menu')" value="1"></el-option>
            <el-option :label="$t('menu.catalog')" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('menu.menuUrl')" prop="menuUrl" v-if="addInfo.type === '1'">
          <el-input
            v-model="addInfo.menuUrl"
            :placeholder="$t('menu.urlPlaceholder')"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('menu.buttonStyle')" prop="menuStyle">
          <el-input
            v-model="addInfo.menuStyle"
            :placeholder="$t('menu.buttonStylePlaceholder')"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('menu.sortNo')" prop="sortNo" class="input-number">
          <el-input-number
            v-model="addInfo.sortNo"
            :placeholder="$t('menu.sortPlaceholder')"
            controls-position="right"
            :min="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="上级单位" prop="controlAreaDepartmentNo">
          <treeselect
            :options="dataList"
            v-model="addInfo.parentMenuCode"
            :defaultExpandLevel="Infinity"
            openDirection="auto"
            :clearable="false"
            :maxHeight="200"
            :zIndex="2999"
            :flat="true"
            :append-to-body="true"
            @select="(val) => selectNode(val)"
            :placeholder="$t('company.treeselect.searchIndex')"
            :noResultsText="$t('company.treeselect.noData')"
            :searchPromptText="$t('company.treeselect.searchIndex')"
          />
        </el-form-item>
        <el-form-item :label="$t('menu.referenceType')" prop="referenceType" class="reference-type">
          <el-select
            v-model="addInfo.referenceType"
            :placeholder="$t('menu.referenceTypePlaceholder')"
            style="width: 100%"
            filterable
          >
            <el-option :label="$t('menu.inner')" value="inner"></el-option>
            <el-option :label="$t('menu.guandata')" value="guandata"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('menu.outUrl')" prop="outUrl">
          <el-input
            v-model="addInfo.outUrl"
            :placeholder="$t('menu.outUrlPlaceholder')"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('menu.remark')" prop="remark">
          <el-input
            v-model="addInfo.remark"
            :placeholder="$t('menu.remarkPlaceholder')"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="addSure()">{{
          $t('dialog.confirm')
        }}</el-button>
        <el-button @click="dialogAdd = false">{{ $t('dialog.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import API from '@/api/systemManage/menu.js';
  export default {
    name: 'addMenu',

    data() {
      return {
        dialogAdd: false,
        loading: false,
        addInfo: {
          menuName: '', //名称
          type: '1', //类型 1是目录 2是菜单
          menuUrl: '', //方法
          sortNo: '', //排序
          remark: '', //备注
          menuStyle: '',
          parentMenuCode: '',
          referenceType: 'inner',
          outUrl: '',
        },
        options: [],
        menu: {},
      };
    },
    props: {
      dataList: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      rules() {
        // 校验特殊字符
        var specialValidate = (rule, value, callback) => {
          var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
          if (value.match(reg)) {
            callback(new Error(this.$t('menu.emoticons')));
          } else {
            callback();
          }
        };
        return {
          menuName: [
            {
              required: true,
              message: this.$t('menu.menunameNotEmpty'),
              trigger: 'blur',
            },
            {
              min: 1,
              max: 40,
              message: this.$t('menu.menunameWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          type: [
            {
              required: true,
              message: this.$t('menu.menunameNotEmpty'),
              trigger: 'change',
            },
          ],
          menuUrl: [
            {
              required: true,
              message: this.$t('menu.menuUrlNotEmpty'),
              trigger: 'blur',
            },
            {
              min: 1,
              max: 40,
              message: this.$t('menu.menunameWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          menuStyle: [
            {
              min: 1,
              max: 40,
              message: this.$t('menu.menunameWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          sortNo: [
            {
              required: true,
              message: this.$t('menu.sortNoNotEmpty'),
              trigger: 'blur',
            },
          ],
          remark: [
            {
              min: 1,
              max: 400,
              message: this.$t('menu.remarkWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
        };
      },
    },
    methods: {
      openDialog(flag, menu) {
        if (this.$refs['insertDialog']) {
          this.$refs['insertDialog'].resetFields();
        }
        this.loading = false;
        this.menu = menu.attributes;
        this.addInfo.parentAuthCode = this.menu.authCode ? this.menu.authCode : '';
        this.addInfo.parentMenuCode = menu.id;
        this.dialogAdd = flag;
      },
      selectNode(node) {
        if (node) {
          this.addInfo.parentAuthCode = node.attributes.authCode;
        }
      },
      //保存
      addSure() {
        this.$refs.insertDialog.validate((valid) => {
          if (valid && !this.loading) {
            this.loading = true;
            this.addInfo.tenantCode = this.menu.tenantCode;
            this.addInfo.applicationCode = this.menu.applicationCode;
            // this.addInfo.parentMenuCode = this.menu.menuCode
            //   ? this.menu.menuCode
            //   : "";
            this.addInfo.level = this.menu.level ? this.menu.level + 1 : 0;
            this.$axios.post(API.ADD_MENU_API, this.addInfo).then((res) => {
              this.loading = false;
              if (0 != res.data.code) {
                this.$alert(res.data.msg);
              } else {
                this.dialogAdd = false;
                this.$emit('getData');
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('message.success'),
                  type: 'success',
                });
              }
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .input-number {
    ::v-deep .el-input-number--small {
      width: 100%;
      .el-input-number__decrease:hover:not(.is-disabled)
        ~ .el-input
        .el-input__inner:not(.is-disabled),
      .el-input-number__increase:hover:not(.is-disabled)
        ~ .el-input
        .el-input__inner:not(.is-disabled) {
        border-color: #00b400;
      }
    }
  }
  .reference-type {
    ::v-deepep .el-select__caret.el-input__icon.el-icon-arrow-up.is-reverse {
      transform: rotateZ(180deg) !important;
    }
    ::v-deepep .el-icon-arrow-up {
      width: 25px;
      background: url('../../../assets/serach/select.svg') center center no-repeat;
      background-size: 20px;
    }
    ::v-deepep .el-select .el-input .el-select__caret {
      transform: rotateZ(0deg);
    }
    ::v-deepep .el-icon-arrow-up:before {
      content: '替';
      font-size: 16px;
      visibility: hidden;
    }
  }
</style>
